export const WITH_W8_OR_W9_FORM_MISSING_FILTER_PARAM = 'with_w8_or_w9_form_missing' as const
export const VENDORS_WITH_INVOICES_FILTER_PARAM = 'vendors_with_invoices' as const
export const WITH_DELETED_FILTER_PARAM = 'with_deleted' as const
